<div class="container-fluid pb-5">

  <div class="d-flex justify-content-between align-items-center mb-4">
    <h3 class="fw-bold text-dark mb-0">
      <span class="lstick"></span> Participant Details
    </h3>
    <button class="btn btn-outline-secondary btn-sm" (click)="goBack()">
      <i class="fa fa-arrow-left mr-1"></i> Back to Participants
    </button>
  </div>

  <div *ngIf="loading" class="text-center py-5">
    <i class="fa fa-spinner fa-spin fa-3x text-primary"></i>
  </div>

  <div *ngIf="!loading && participation">

    <!-- Participation Info -->
    <div class="card mb-4 shadow-sm">
      <div class="card-header"><strong>Participation Information</strong></div>
      <div class="card-body row">
        <div class="col-md-4 mb-2">
          <b>Order Number:</b> {{ participation?.orderNumber || '-' }}
        </div>
        <div class="col-md-4 mb-2">
          <b>Participation Date:</b> {{ participation?.participationDate | date: 'medium' }}
        </div>
        <div class="col-md-4 mb-2">
          <b>Status:</b>
          <span class="badge ml-2" [ngClass]="{
              'badge-success': participation?.participationStatus === 'active',
              'badge-warning': participation?.participationStatus === 'pending',
              'badge-danger': participation?.participationStatus === 'inactive'
            }">
            {{ participation?.participationStatus | titlecase }}
          </span>
        </div>
      </div>
    </div>

    <!-- User Info -->
    <div class="card mb-4 shadow-sm">
      <div class="card-header"><strong>User Information</strong></div>
      <div class="card-body row">
        <div class="col-md-4 mb-2"><b>Name:</b> {{ user?.name || '-' }}</div>
        <div class="col-md-4 mb-2"><b>Username:</b> {{ user?.username || '-' }}</div>
        <div class="col-md-4 mb-2"><b>Email:</b> {{ user?.email || '-' }}</div>
        <div class="col-md-4 mb-2"><b>Phone:</b> {{ user?.phone_number || user?.mobile || '-' }}</div>
      </div>
    </div>

    <!-- Lottery Info -->
    <div class="card mb-4 shadow-sm">
      <div class="card-header"><strong>Lottery Information</strong></div>
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-md-4 mb-2">
            <b>Lottery Name:</b> {{ lottery?.lotteryName || '-' }}
          </div>
          <div class="col-md-4 mb-2">
            <b>Expiry Date:</b> {{ lottery?.expiryDate | date: 'mediumDate' }}
          </div>
          <div class="col-md-4 mb-2">
            <b>Required Orders:</b> {{ lottery?.requiredOrders ?? '-' }}
          </div>
          <div class="col-md-4 mb-2">
            <b>Total Participated Orders:</b> {{ lottery?.totalParticipatedOrders ?? '-' }}
          </div>
          <div class="col-md-4 mb-2">
            <b>Lottery Status:</b>
            <span class="badge ml-2" [ngClass]="{
                'badge-success': lottery?.status === 'active',
                'badge-info': lottery?.status === 'completed',
                'badge-secondary': lottery?.status !== 'active' && lottery?.status !== 'completed'
              }">
              {{ lottery?.status | titlecase }}
            </span>
          </div>
          <div class="col-md-4 mb-2">
            <b>Winner Type:</b>
            <span class="badge ml-2"
              [ngClass]="lottery?.winnerSelectionType === 'multiple' ? 'badge-info' : 'badge-secondary'">
              {{ lottery?.winnerSelectionType | titlecase }}
            </span>
          </div>
        </div>
        <div class="row">
          <!-- Winner Configuration -->
          <div *ngIf="lottery?.winnerConfiguration?.length > 0" class="mt-3 col-md-6">
            <b>Winner Configuration:</b>
            <table class="table table-bordered table-sm mt-2" style="max-width: 400px;">
              <thead class="table-light">
                <tr>
                  <th>Rank</th>
                  <th>Prize Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let wc of lottery.winnerConfiguration">
                  <td>{{ wc.rank }}</td>
                  <td>{{ wc.prizeAmount | number }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Winners -->
          <div *ngIf="lottery?.winners?.length > 0" class="mt-3 col-md-6">
            <b>Winners:</b>
            <table class="table table-bordered table-sm mt-2" style="max-width: 500px;">
              <thead class="table-light">
                <tr>
                  <th>Rank</th>
                  <th>Prize Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let w of lottery.winners">
                  <td>{{ w.rank }}</td>
                  <td>{{ w.prizeAmount | number }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>


      </div>
    </div>

    <!-- Store Info -->
    <div class="card mb-4 shadow-sm">
      <div class="card-header"><strong>Store Information</strong></div>
      <div class="card-body row align-items-center">
        <div class="col-md-2 mb-2" *ngIf="store?.storeImage">
          <img [src]="store.storeImage" alt="Store" class="img-fluid rounded" style="max-height: 80px;" />
        </div>
        <div class="col mb-2">
          <div><b>Store Name:</b> {{ store?.storeName || '-' }}</div>
          <div class="mt-1"><b>Description:</b> {{ store?.storeDescription || '-' }}</div>
        </div>
      </div>
    </div>

    <!-- Order Details -->
    <div class="card mb-4 shadow-sm">
      <div class="card-header"><strong>Order Details</strong></div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-4 mb-2">
            <b>Order Number:</b> {{ order?.orderNumber || '-' }}
          </div>
          <div class="col-md-4 mb-2">
            <b>Invoice Number:</b> {{ order?.invoice_number || '-' }}
          </div>
          <div class="col-md-4 mb-2">
            <b>Status:</b>
            <span class="badge ml-2" [ngClass]="{
                'badge-success': order?.status === 'completed',
                'badge-warning': order?.status === 'pending',
                'badge-danger': order?.status === 'cancelled'
              }">
              {{ order?.status | titlecase }}
            </span>
          </div>
          <div class="col-md-4 mb-2">
            <b>Total (With VAT):</b> {{ order?.totalAmountWithVat | number: '1.2-2' }} {{ order?.currency }}
          </div>
          <div class="col-md-4 mb-2">
            <b>Total (Without VAT):</b> {{ order?.totalAmountWithoutVat | number: '1.2-2' }} {{ order?.currency }}
          </div>
          <div class="col-md-4 mb-2">
            <b>VAT Amount:</b> {{ order?.totalVatAmount | number: '1.2-2' }} {{ order?.currency }}
          </div>
          <div class="col-md-4 mb-2">
            <b>Delivery Type:</b> {{ order?.deliveryType | titlecase }}
          </div>
          <div class="col-md-4 mb-2">
            <b>Delivery Price:</b> {{ order?.deliveryPrice | number: '1.2-2' }} {{ order?.currency }}
          </div>
          <div class="col-md-4 mb-2">
            <b>Refunded:</b>
            <span class="badge ml-2" [ngClass]="order?.refunded ? 'badge-danger' : 'badge-success'">
              {{ order?.refunded ? 'Yes' : 'No' }}
            </span>
          </div>
          <div class="col-md-8 mb-2">
            <b>Delivery Address:</b> {{ order?.userAddress || '-' }}
          </div>
          <div class="col-md-4 mb-2">
            <b>Payment Method:</b> {{ order?.paymentMethodType | titlecase }}
          </div>
        </div>

        <!-- Order Items -->
        <div *ngIf="order?.vendingPackagesItems?.length > 0">
          <b>Purchased Items:</b>
          <div class="table-responsive mt-2">
            <table class="table table-bordered table-sm">
              <thead class="table-light">
                <tr>
                  <th>#</th>
                  <th>Product Name</th>
                  <th>Qty</th>
                  <th>Amount (Without VAT)</th>
                  <th>VAT %</th>
                  <th>VAT Amount</th>
                  <th>Total</th>
                  <th>Refunded</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of order.vendingPackagesItems; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item?.packageId?.name || '-' }}</td>
                  <td>{{ item?.quantity }}</td>
                  <td>{{ item?.totalAmountWithoutVat | number: '1.2-2' }}</td>
                  <td>{{ item?.totalVatPercentage }}%</td>
                  <td>{{ item?.totalVatAmount | number: '1.2-2' }}</td>
                  <td>{{ item?.chargeableAmount | number: '1.2-2' }}</td>
                  <td>
                    <span class="badge" [ngClass]="item?.refunded ? 'badge-danger' : 'badge-success'">
                      {{ item?.refunded ? 'Yes' : 'No' }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div *ngIf="!loading && !participation" class="text-center text-muted py-5">
    <i class="fa fa-exclamation-circle fa-2x mb-2"></i>
    <p>Participant details not found.</p>
  </div>

</div>